import React, {Component} from 'react';
import uuidv4 from 'uuid/v4';
import Dropzone from './Dropzone';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import LinearProgress from '@material-ui/core/LinearProgress';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import IconButton from '@material-ui/core/IconButton';
import Icon from '@material-ui/core/Icon';

import './style.css';

import {firebase} from '../../../../config/firebase';
import { getDuration, getAudioWaveformData } from '../../../../utils';

class FileUploader extends Component {
  constructor(props) {
    super(props);

    this.state = {
      uploads: [],
    }

    this.dbFilesRef      = firebase.database().ref('/content/files')
    this.storageMediaRef = firebase.storage().ref('/media')

    this.handleOnDrop             = this.handleOnDrop.bind(this);
    this.handleUploadStateChange  = this.handleUploadStateChange.bind(this);
    this.handleUploadError        = this.handleUploadError.bind(this);
    this.handleUploadSuccess      = this.handleUploadSuccess.bind(this);
    this.generateFileStorageName  = this.generateFileStorageName.bind(this);
    this.uploadingFilesListMarkup = this.uploadingFilesListMarkup.bind(this);
    this.handlePlayPauseToggle    = this.handlePlayPauseToggle.bind(this);
    this.handleUploadCancel       = this.handleUploadCancel.bind(this);
  }

  handleOnDrop(files) {
    const uploads = [];
    files.forEach(file => {
      const storageFilename = this.generateFileStorageName(file.name);
      const uploadTask = this.storageMediaRef.child(storageFilename).put(file);

      uploadTask.on(
        'state_changed',
        (snapshot) => this.handleUploadStateChange(snapshot, storageFilename),
        (error) => this.handleUploadError(storageFilename, error),
        () => this.handleUploadSuccess(file, storageFilename)
      );

      uploads.push({
        title: file.name,
        filename: storageFilename,
        progress: 0,
        paused: false,
        error: null,
        task: uploadTask,
      })
    })

    this.setState({
      uploads: [...this.state.uploads, ...uploads],
    })
  }

  handleUploadStateChange(snapshot, filename) {
    let progress = Math.round((snapshot.bytesTransferred / snapshot.totalBytes) * 100);
    let paused = false;
    if (snapshot.state === firebase.storage.TaskState.PAUSED) {
      paused = true;
    }

    this.setState({
      uploads: this.state.uploads.map(upload => {
        if (upload.filename === filename) {
          return {...upload, progress, paused}
        }

        return upload;
      })
    })
  }

  handleUploadError(filename, error) {
    this.setState({
      uploads: this.state.uploads.map(upload => {
        if (upload.filename === filename) {
          return {...upload, error: true}
        }
        return upload;
      }),
    });
    console.error(error.message);
  }

  handleUploadSuccess(file, filename) {
    this.storageMediaRef.child(filename).getDownloadURL().then(async (url) => {
      const type = filename.endsWith('.mp3') ? 'audio' : 'video';
      let duration;
      let waveformData;

      if (type === 'audio') {
        [duration, waveformData] = await Promise.all([
          getDuration(file, type),
          getAudioWaveformData(file, 100),
        ]);
      } else {
        duration = await getDuration(file, type);
      }

      this.dbFilesRef.push({
        title: file.name,
        name: filename,
        url,
        duration: Math.ceil(duration),
        waveformData: waveformData ? waveformData.join(',') : null,
      });
      this.setState({
        uploads: this.state.uploads.filter(upload => upload.filename !== filename),
      });
    });
  }

  handlePlayPauseToggle(upload) {
    if (upload.paused) {
      upload.task.resume();
    } else {
      upload.task.pause();
    }
  }

  handleUploadCancel(upload) {
    upload.task.cancel();
    this.setState({
      uploads: this.state.uploads.filter(u => u.filename !== upload.filename)
    })
  }

  generateFileStorageName(name) {
    const guid = uuidv4();
    const extension = name.split('.').pop();
    const filename = `${guid}.${extension}`;
    return filename;
  }

  uploadingFilesListMarkup() {
    const {uploads} = this.state
    if (uploads.length === 0) {
      return null;
    }

    const listItems = uploads.map(upload => (
      <ListItem key={upload.filename} divider>
        <ListItemText>
          <span className="upload-title">{upload.title}</span>
          {upload.error && <p style={{color: 'red'}}>Error uploading this file.</p>}
          <LinearProgress variant="determinate" value={upload.progress} />
        </ListItemText>
        <ListItemSecondaryAction>
          <IconButton aria-label={upload.paused ? 'start' : 'pause'} onClick={() => this.handlePlayPauseToggle(upload)}>
            <Icon>{upload.paused ? 'play_arrow' : 'pause'}</Icon>
          </IconButton>
          <IconButton aria-label="Cancel" onClick={() => this.handleUploadCancel(upload)}>
            <Icon>cancel</Icon>
          </IconButton>
        </ListItemSecondaryAction>
      </ListItem>
    ))

    return (
      <div>
        <h6>Uploading {uploads.length} {uploads.length === 1 ? 'file' : 'files'}</h6>
        <List>{listItems}</List>
      </div>
    )
  }

  render() {
    return (
      <div className="file-uploader">
        <Dropzone onDrop={this.handleOnDrop} />
        <br/>
        {this.uploadingFilesListMarkup()}
      </div>
    )
  }
}

export default FileUploader



// WEBPACK FOOTER //
// ./src/scenes/Dashboard/components/FileUploader/index.js